import { ModifyIdentity } from '@grid/models';
import { DataType } from '@shared/models';
import { DprForecastActivityCustomData } from '@shared/models/dpr';

export interface DprForecastActivityCustomDataGridData
  extends ModifyIdentity<DprForecastActivityCustomData> {
  decimalCount?: number;
  dataTypeId?: DataType;
  remarks?: string;
  name?: string;
}
